export default __webpack_public_path__ + "static/media/WhatsApp Image2.aefe11ca.jpeg";